module.exports = __webpack_public_path__ + "img/stage4.509154fd.png";